import React from 'react';
import { TaskCardLayout } from './TaskCard';
import { TaskCard } from '@medely/ui-kit';
import { useProNavigate } from '@mp/contexts';

export const SchedulerPreferencesCard = () => {
  const { navigate } = useProNavigate();

  return (
    <TaskCardLayout>
      <TaskCard
        iconProps={{ name: 'light-calendar-day', color: 'success' }}
        title="Scheduling preferences"
        body="Update your availability and shift preferences"
        onClick={() => navigate('SchedulingPreferences')}
      />
    </TaskCardLayout>
  );
};
